<template>
    <div>
        <template v-if="initialized && enabled">
            <h6 :class="printable ? 'text-left mb-0' : 'text-center'">
                <strong>{{ header }}</strong>
            </h6>

            <div class="mb-2" :class="printable ? 'text-left' : 'text-center'">
                <template v-if="body && body.length > 0">
                    <div
                        v-if="!printable"
                        class="col-12 mt-3"
                        :class="[
                            'collapsable-description',
                            showFullBody
                                ? 'collapsable-description-open'
                                : 'collapsable-description-collapsed',
                        ]"
                        @click.prevent="setShowFullBody(!showFullBody)"
                    >
                        <p v-html="body"></p>
                    </div>
                    <div v-else v-html="body" class="mb-0"></div>
                </template>

                <a
                    v-if="!printable"
                    href="#"
                    type="button"
                    class="collapsable-description-toggle signbuttoninline shadow-sm"
                    @click.prevent="setShowFullBody(!showFullBody)"
                    style="
                        border: 1px solid gray !important;
                        color: gray !important;
                        background-color: white !important;
                        text-decoration: none;
                    "
                >
                    {{ $t("quoteProducts.view.view_more") }}
                </a>
            </div>

            <div v-if="printable" class="row">
                <a
                    v-for="(link, idx) in links"
                    :key="idx"
                    class="col-12 mb-2"
                    :href="link.url"
                    target="_blank"
                >
                    <strong>{{ link.title }}</strong
                    ><br />
                    {{ link.url }}
                </a>
            </div>
            <div v-else class="row">
                <a
                    v-for="(link, idx) in links"
                    :key="idx"
                    class="col-6 mt-3 text-center"
                    :href="link.url"
                    target="_blank"
                >
                    {{ link.title }}
                </a>
            </div>
        </template>
        <template v-else-if="!initialized">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">{{ $t("general.loading") }}...</span>
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
a {
    color: black;
    text-decoration: underline;
}

.collapsable-description {
    transition: max-height 0.5s ease-in-out;
    overflow: hidden;
    max-height: 10000px;
    position: relative;

    & + .collapsable-description-toggle {
        position: relative;
        top: -20px;

        margin-left: auto;
        margin-right: auto;
    }
}

.collapsable-description-open {
    & + .collapsable-description-toggle {
        display: none;
    }
}

.collapsable-description-collapsed {
    cursor: pointer;
    max-height: 8em;

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 4em;
        text-align: center;
        margin: 0;
        padding: 30px 0;

        pointer-events: none;

        background-image: linear-gradient(to bottom, transparent, white);
    }
}
</style>

<script setup>
import axios from "axios";
import { computed, onMounted, ref } from "vue";

const props = defineProps({
    quoteKey: { type: String, default: undefined },
    printable: { type: Boolean, default: false },
});

const enabled = ref(undefined);
const header = ref(undefined);
const body = ref(undefined);
const links = ref(undefined);
const showFullBody = ref(false);
const initialized = computed(() => enabled.value !== undefined);

onMounted(async () => {
    try {
        const response = await axios.get(`/quote/${props.quoteKey}/terms`);
        enabled.value = true;
        header.value = response.data.header;
        body.value = response.data.body;
        links.value = response.data.links;
    } catch (error) {
        if (!error.response || error.response.status !== 404) {
            throw error;
        }
        enabled.value = false;
    }
});

function setShowFullBody(value) {
    showFullBody.value = value;
}
</script>
